// Retain the optional ten-minute offer timer without replacing Dawn's variant handlers.
if (!customElements.get('manis-product-offer')) {
  customElements.define('manis-product-offer', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.timer = this.querySelector('.timer_text #timer');
      if (!this.timer) return;

      let saved;
      try {
        saved = document.cookie.split('; ').find((cookie) => cookie.startsWith('timer='))?.slice(6);
      } catch (_) {
        // The countdown still works when cookie access is unavailable.
      }
      const seconds = Number(saved);
      this.seconds = saved && Number.isInteger(seconds) && seconds >= 0 && seconds <= 600 ? seconds : 600;
      this.querySelectorAll('.timer_text').forEach((element) => element.classList.remove('hidden'));
      this.renderTime();
      this.interval = setInterval(() => {
        this.seconds = this.seconds === 0 ? 600 : this.seconds - 1;
        this.renderTime();
        try {
          document.cookie = `timer=${this.seconds};max-age=600;path=/;SameSite=Lax`;
        } catch (_) {
          // Cookie persistence is optional.
        }
      }, 1000);
    }

    renderTime() {
      const minutes = Math.floor(this.seconds / 60);
      const seconds = this.seconds % 60;
      this.timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    disconnectedCallback() {
      if (this.interval !== undefined) clearInterval(this.interval);
      this.interval = undefined;
    }
  });
}
